import Api from '@/services/api';

export default {
  bootstrap() {
    return Api().get('/newsletters/bootstrap');
  },
  list() {
    return Api().get('/newsletters/list');
  },
  send(data) {
    return Api().post('/newsletters/send', 'data=' + encodeURIComponent(JSON.stringify(data)));
  },
  groups() {
    return Api().get('/newsletters/groups');
  },
  group(id) {
    return Api().get('/newsletters/group/' + id);
  },
  delete_group(id) {
    return Api().delete('/newsletters/group/' + id);
  },
  add_csv_file(id, file) {
    return Api().post('/newsletters/group/'+ id + '/add-csv', file);
  },
  add_mails(groupId, mails) {
    return Api().post('/newsletters/group/' + groupId + '/add-free-mails', 'mails=' + encodeURIComponent(mails))
  },
  update_group(data) {
    return Api().post('/newsletters/group/' + data.ID , 'data=' + encodeURIComponent(JSON.stringify(data)));
  },
  create_group(data) {
    return Api().post('/newsletters/group', 'data=' + encodeURIComponent(JSON.stringify(data)));
  },
  delete_mail(groupId, mail) {
    return Api().delete('/newsletters/group/' + groupId + '/mail/' + encodeURIComponent(mail));
  }
}